export default {
	Type: {
		ADDRESS: "S",
		TRANSPORT: "T",
	},
};
